import { AxiosResponse } from "axios";

import {
  IStaffDetails,
  IStaffListItem,
  IStaffUser,
  IUpdateStaffRequest,
  IUpdateStaffUserRequest,
} from "../../@types/admin/AdminStaff";
import { IPaginatedResponse } from "../../@types/PaginatedResponse";
import { api } from "../api";

/**
 * Staff admin pages (EN-5150), migrated from the Retool StaffList app and
 * moduleStaffDetails. The details panel edits two records that live behind
 * different endpoints: the staff row (/Retool/Staff) and the linked user
 * account (/Retool/Users), keyed by the `userId` on the staff response.
 */
export const staffService = {
  async getStaffList(): Promise<
    AxiosResponse<IPaginatedResponse<IStaffListItem[]>>
  > {
    return api.get<IPaginatedResponse<IStaffListItem[]>>("/Retool/Staff");
  },

  async getStaffById(staffId: number): Promise<AxiosResponse<IStaffDetails>> {
    return api.get<IStaffDetails>(`/Retool/Staff/${staffId}`);
  },

  async updateStaff(
    request: IUpdateStaffRequest
  ): Promise<AxiosResponse<void>> {
    return api.put<void>(`/Retool/Staff/${request.id}`, request);
  },

  /** Re-enables a deactivated staff member (Cognito + CMS flags). */
  async reactivateStaff(staffId: number): Promise<AxiosResponse<void>> {
    return api.put<void>(`/Retool/Staff/Reactivate/${staffId}`);
  },

  async getUserById(userId: number): Promise<AxiosResponse<IStaffUser>> {
    return api.get<IStaffUser>(`/Retool/Users/${userId}`);
  },

  async updateUser(
    request: IUpdateStaffUserRequest
  ): Promise<AxiosResponse<IStaffUser>> {
    return api.put<IStaffUser>(`/Retool/Users/${request.id}`, request);
  },
};
